import * as React from 'react';
const SwanListboxContext = /*#__PURE__*/React.createContext(undefined);
const SwanListboxContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [labelMap, setLabelMap] = React.useState({});
  const value = React.useMemo(() => {
    return {
      labelMap,
      setLabelMap
    };
  }, [labelMap, setLabelMap]);
  return /*#__PURE__*/React.createElement(SwanListboxContext.Provider, {
    value: value
  }, children);
};
function useSwanListboxContext() {
  const ctx = React.useContext(SwanListboxContext);
  if (!ctx) {
    throw new Error("useSwanListboxContext should be used inside ListboxContextProvider");
  }
  return ctx;
}
export { SwanListboxContextProvider, useSwanListboxContext };